import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import DashboardCliente from '../../components/Dashboard/DashboardCliente';
import DashboardEntidade from '../../components/Dashboard/DashboardEntidade';
import DashboardBackoffice from '../../components/Dashboard/DashboardBackoffice';
import { Box, CircularProgress, Typography } from '@mui/material';

const Dashboard: React.FC = () => {
  const { t } = useTranslation();
  const { user, loading } = useAuth();

  // Loading state
  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
        }}
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  // No user state
  if (!user) {
    return (
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <Typography variant="h5" color="text.secondary">
          {t('dashboard.noUser')}
        </Typography>
      </Box>
    );
  }

  // Business/entity roles — all merchant and organisation profiles
  const ENTITY_ROLES = ['PFENT', 'PFDEV', 'PFCON', 'PFLOJ', 'PFEMP', 'PFGOV', 'PFONG', 'PFEVT', 'PFPRO', 'PFFOD', 'PFCOL', 'PFOPE', 'PFCHF', 'PFGAR', 'PFMOT', 'consultant'];

  // Render dashboard based on user role
  const renderDashboard = () => {
    if (user.role === 'PFADM' || user.role === 'admin') {
      return <DashboardBackoffice />;
    }
    if (ENTITY_ROLES.includes(user.role)) {
      return <DashboardEntidade />;
    }
    // PFCLI and any unknown role → client dashboard
    return <DashboardCliente />;
  };

  return <Box>{renderDashboard()}</Box>;
};

export default Dashboard;
